/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HealthCheck200Response
 */
export interface HealthCheck200Response {
    /**
     * 
     * @type {string}
     * @memberof HealthCheck200Response
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCheck200Response
     */
    timestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCheck200Response
     */
    environment?: string;
}

/**
 * Check if a given object implements the HealthCheck200Response interface.
 */
export function instanceOfHealthCheck200Response(value: object): value is HealthCheck200Response {
    return true;
}

export function HealthCheck200ResponseFromJSON(json: any): HealthCheck200Response {
    return HealthCheck200ResponseFromJSONTyped(json, false);
}

export function HealthCheck200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthCheck200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'timestamp': json['timestamp'] == null ? undefined : json['timestamp'],
        'environment': json['environment'] == null ? undefined : json['environment'],
    };
}

export function HealthCheck200ResponseToJSON(json: any): HealthCheck200Response {
    return HealthCheck200ResponseToJSONTyped(json, false);
}

export function HealthCheck200ResponseToJSONTyped(value?: HealthCheck200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'timestamp': value['timestamp'],
        'environment': value['environment'],
    };
}

